__turbopack_context__.v({
  "extraLabel": "ExtraLabel-module-scss-module__VK5wea__extraLabel",
  "title": "ExtraLabel-module-scss-module__VK5wea__title",
});
